module.exports = __webpack_public_path__ + "c4d4b2ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/customers/talentify.jpg
// module id = 760
// module chunks = 2